import styled from 'styled-components';
import React, { useState } from 'react';

export function useCopyToClipboard(timeout = 1200) {
  const [copied, setCopied] = useState(false);
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), timeout);
  };
  return [copied, copyToClipboard];
}

export const RequestTracerWrapper = styled.div`
  padding: 24px;
  max-width: 600px;
  margin: 0;
  text-align: left;
`;

export const RequestTracerHeaderRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

export const RequestTracerHeading = styled.h2`
  margin: 0;
  margin-right: 16px;
`;

export const RequestTracerSearchButton = styled.button`
  border: none;
  background: #1890ff;
  color: white;
  border-radius: 4px;
  padding: 4px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
`;

export const RequestTracerTableContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;

  && .ant-table-row.selected-row {
    background-color: #bae7ff !important;
    transition: background 0.2s;
  }

  .ant-table-row.ant-table-row-selected {
    background-color: #bae7ff !important;
    transition: background 0.2s;
  }

  .selected-row {
    background-color: #e6f7ff !important;
  }
`;

export const FullWidthRequestTracerWrapper = styled(RequestTracerWrapper)`
  width: 100vw;
  max-width: 100vw;
  padding: 0 32px; /* Equal space left and right */
  box-sizing: border-box;
`;

export const BooleanBubbleStyled = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 12px;
  min-width: 48px;
  font-weight: 600;
  font-size: 13px;
  background: ${({ $isTrue }) => ($isTrue ? '#e6fffb' : '#fff1f0')};
  color: ${({ $isTrue }) => ($isTrue ? '#389e0d' : '#cf1322')};
  border: 1px solid ${({ $isTrue }) => ($isTrue ? '#b7eb8f' : '#ffa39e')};
  justify-content: center;
`;

export const DQStatusBubble = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 12px;
  min-width: 48px;
  font-weight: 600;
  font-size: 13px;
  background: ${({ $isQualified }) => ($isQualified ? '#e6fffb' : '#fff1f0')};
  color: ${({ $isQualified }) => ($isQualified ? '#389e0d' : '#cf1322')};
  border: 1px solid ${({ $isQualified }) => ($isQualified ? '#b7eb8f' : '#ffa39e')};
  justify-content: center;
  text-transform: lowercase;
`;

export const SummaryRowGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 20px;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const SummaryRowContainer = styled.div`
  margin-bottom: 20px;
  position: relative;
  display: flex;
  align-items: flex-start;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 0;
  background: none;

  &:hover .hover-copy-icon,
  &:hover .hover-link-icon {
    opacity: 1 !important;
  }
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const SummaryRowHeading = styled.div`
  font-weight: 500;
  min-width: 160px;
  font-size: 15px;
`;

export const SummaryRowValue = styled.div`
  margin: 4px 0 0 0;
  word-break: break-word;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const SummaryRowValueText = styled.span`
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const RowContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &:hover .hover-copy-icon,
  &:hover .hover-link-icon {
    opacity: 1 !important;
  }
`;

export const RowHeading = styled.div`
  font-weight: 600;
  min-width: 120px;
`;

export const RowValue = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
`;

export const IconButtonMargin = styled.span`
  margin-left: 4px;
  display: inline-flex;
`;

export const HoverCopyIcon = styled.span`
  opacity: 0;
  transition: opacity 0.2s;
  display: inline-flex;
  pointer-events: auto;
  &:focus-within {
    opacity: 1 !important;
  }
`;

export const HoverLinkIcon = styled.span`
  opacity: 0;
  transition: opacity 0.2s;
  display: inline-flex;
  pointer-events: auto;
  &:focus-within {
    opacity: 1 !important;
  }
`;

export const CopiedToClipboardBubble = styled.div`
  position: absolute;
  left: 50%;
  bottom: -32px;
  transform: translateX(-50%);
  background: #222;
  color: #fff;
  border-radius: 4px;
  padding: 6px 18px;
  font-size: 15px;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BorderedSearchIcon = styled.span`
  cursor: pointer;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 2px;
  background: none;
  transition: background 0.2s;
  &:hover {
    background: #f5f5f5;
  }
  & .anticon-search {
    font-size: 16px;
    color: #333;
    background: none;
    border: none;
  }
`;

export const SummarySectionDivider = styled.div`
  width: 100%;
  height: 0;
  border-bottom: 2px solid #e0e0e0;
  margin: 24px 0 16px 0;
`;

export const DrawerTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export function renderDQStatusBubble(value) {
  const formatted = formatDQStatus(value);
  const isQualified = formatted === 'qualified';
  return <DQStatusBubble $isQualified={isQualified}>{isQualified ? 'qualified' : formatted}</DQStatusBubble>;
}

export const SummaryRowValueRight = styled(SummaryRowValue)`
  justify-content: flex-end;
  width: 100%;
`;

// Utility to render a boolean value as a styled bubble
export function getDQStatusBubble(value) {
  const formatted = formatDQStatus(value);
  const isQualified = formatted === 'qualified';
  return <DQStatusBubble $isQualified={isQualified}>{isQualified ? 'qualified' : formatted}</DQStatusBubble>;
}

// Utility to render a boolean value as a styled bubble (green for true, red for false)
export function getBooleanBubble(value) {
  const boolVal = value === true || value === 'true';
  return <BooleanBubbleStyled $isTrue={boolVal}>{boolVal ? 'true' : 'false'}</BooleanBubbleStyled>;
}

// Utility to truncate a value for preview display (used in detail panels)
export const getTruncatedValue = (value) => {
  if (value === undefined || value === null) return value;
  let str = value;
  if (typeof value === 'object') {
    try {
      str = JSON.stringify(value);
    } catch {
      str = String(value);
    }
  }
  if (typeof str !== 'string') str = String(str);
  const parts = str.split(',');
  if (parts.length <= 3) return str;
  return parts.slice(0, 3).join(',') + ', ...';
};

// Utility to get value for a key from an object, with fallback and stringification
export const getVal = (obj, key) => {
  const val = obj ? obj[key] : undefined;
  if (val === undefined || val === null || val === '') {
    return 'N/A';
  }
  if (typeof val === 'boolean') {
    return val ? 'true' : 'false';
  }
  if (typeof val === 'object' && val !== null) {
    try {
      return JSON.stringify(val);
    } catch {
      return String(val);
    }
  }
  return val;
};

// Utility to open JSON data in a new browser tab
export function OpenJsonInNewTab(data) {
  let jsonString = '';
  try {
    jsonString = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
  } catch (e) {
    jsonString = String(data);
  }
  // Open a new tab and set window.name to the JSON string, then load the React JSON viewer route
  const newTab = window.open('', '_blank');
  if (newTab) {
    newTab.name = jsonString;
    newTab.location = '/json-viewer';
  }
}

// Utility to format summary values based on key
export function getFormattedValue(key, value) {
  if (key === 'DQ Status') return getDQStatusBubble(value);
  if (key === 'Invariant Qualified' || key === 'Slot Qualified' || key === 'Filler Only')
    return getBooleanBubble(value);
  if (value === undefined || value === null || value === '') return 'N/A';
  return value;
}

// Shared summary column for DRY two-column rows
export const SummaryColumn = ({
  label,
  value,
  isBoolean = false,
  isDQStatus = false,
  getBooleanBubble,
  getFormattedValue,
}) => (
  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
    <SummaryRowHeading>{label}</SummaryRowHeading>
    <SummaryRowValue style={{ marginTop: 4 }}>
      <SummaryRowValueText>
        {isBoolean && getBooleanBubble
          ? getBooleanBubble(value)
          : isDQStatus
          ? (() => {
              const formatted = formatDQStatus(value);
              const isQualified = formatted === 'qualified';
              return (
                <DQStatusBubble $isQualified={isQualified}>{isQualified ? 'qualified' : formatted}</DQStatusBubble>
              );
            })()
          : getFormattedValue
          ? getFormattedValue(label, value)
          : value === undefined || value === null || value === ''
          ? 'N/A'
          : value}
      </SummaryRowValueText>
    </SummaryRowValue>
  </div>
);

export const TwoColumnSummaryRow = ({
  leftLabel,
  leftValue,
  rightLabel,
  rightValue,
  leftIsBoolean = false,
  rightIsBoolean = false,
  leftIsDQStatus = false,
  rightIsDQStatus = false,
  getBooleanBubble,
  getFormattedValue,
}) => (
  <SummaryRowGroup style={{ display: 'flex', flexDirection: 'row', gap: 24, width: '100%' }}>
    <SummaryColumn
      label={leftLabel}
      value={leftValue}
      isBoolean={leftIsBoolean}
      isDQStatus={leftIsDQStatus}
      getBooleanBubble={getBooleanBubble}
      getFormattedValue={getFormattedValue}
    />
    <SummaryColumn
      label={rightLabel}
      value={rightValue}
      isBoolean={rightIsBoolean}
      isDQStatus={rightIsDQStatus}
      getBooleanBubble={getBooleanBubble}
      getFormattedValue={getFormattedValue}
    />
  </SummaryRowGroup>
);

export const ErrorBox = styled.div`
  background: #fff;
  border: 1.5px solid #e53935;
  color: #000;
  padding: 18px 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(229, 57, 53, 0.08);
  font-size: 16px;
`;

export const ErrorList = styled.ul`
  margin: 0;
  padding-left: 20px;
`;

export const ErrorListItem = styled.li`
  margin-bottom: 6px;
`;

export function formatDQStatus(value) {
  if (!value) return 'unknown';
  const str = String(value).toLowerCase();
  if (str === 'qualified') return 'qualified';
  if (str === 'disqualified') return 'disqualified';
  return str;
}
